import SelectDropdown from "../../components/searchSelect";
import AnnualReport from "./AnnualReport";
import { BackButtonWrap, ContentWrapper, DescriptionItem, DescriptionWrapper, DownArrowIcon, FlexContainer, HeaderContainer, HeaderTitleWrap, IsnNumberWraper, TabItem, TableContainer, Tabs, TabWrapper, WrapperContainer } from "./Innerpage.style"
import {useEffect, useState} from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import LoadingEffect from "../../components/LoadingEffect";
import languageList from '../../assets/language/language.json';
import { toast } from "react-toastify";

const MiflInnerPage = () => {
    const navigate = useNavigate();
    const {org, id, type} = useParams();
    const [searchParams] = useSearchParams();
    const language = searchParams.get("lang") || 'en';
    const [activeTab, setActiveTab] = useState("first")
    const [loading, setLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const { get } = useHttp();
    const [labels, setLabelList] = useState([]);
    const [dataSet, setDataSet] = useState([]);
    const [fundDetails, setFundDetails] = useState();
    const [version, setVersion] = useState([]);
    const [scenarioData, setScenarioData] = useState();
    const [performanceHistory, setPerformanceHistory] = useState(0);
    const [languages, setLanguage] = useState(null)

    useEffect(() => {
        if(languageList[language]){
            setLanguage(languageList[language])
        } else {
            setLanguage(languageList['en'])
        }

    }, [language])

    const [noData, setNoData] = useState(false);
    useEffect(()=> {
        if(dataSet.length) {
            setNoData(dataSet.every((value) => value == null || value === 0))
            const firstNonZeroIndex = dataSet.findIndex(item => item !== 0);
            setPerformanceHistory(firstNonZeroIndex === -1 ? 0 : dataSet.length - firstNonZeroIndex);
        }
        else {
            setNoData(true);
            setPerformanceHistory(0);
        }
    },[dataSet])
    const getPastPerformanceData = async() => {
        setLoading(true)
        try {
            const response = await get({endpoint: endpoints.mifl.getPastPerformance + id });
            setDataSet((response?.data||[])?.map(el => el.value || 0));
            setLabelList(response?.data?.map(el => el.year));
            setFundDetails({...response.fund_details})
            setLoading(false)
        } catch (err) {
            if(err?.status === 400)
                toast.error(err?.response?.data?.message || "Something went wrong. Please try again later.")
            else {
                toast.error("Something went wrong. Please try again later.")
            }
            // setListItems([])
            setLoading(false)
        }
    }

    const translateLabels = (data) => {
        return data.map(item => {
          const [monthName, year] = item.label.split(" ");
          const translatedMonth = languages?.[monthName.toLowerCase()] || monthName;
          return {
            ...item,
            label: `${translatedMonth} ${year}`
          };
        });
    }

    const getPastScenarioDates = async() => {
        setLoading(true)
        try {
            const response = await get({endpoint: `${endpoints.mifl.getPastPerformanceDates}${id}/${type}` });
            console.log("setting version here", response.dates)
            setVersion(translateLabels(response.dates) || [])
            setScenarioData(response.latest_data||{})
            setLoading(false)
        } catch (err) {
            // setListItems([])
            setLoading(false)
        }
    }
    
    const getPastScenarioTable = async(option) => {
        setTableLoading(true)
        try {
            const response = await get({endpoint: `${endpoints.mifl.getPastPerformanceScenario}${id}/${type}/${option.year}/${option.month}` });
            setScenarioData(response.data||{})
            setTableLoading(false)
        } catch (err) {
            // setListItems([])
            setTableLoading(false)
        }
    }
    const formatAmount = (amount) => {
        return Number(amount)?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })
    }
    const formatPcnt = (value) => {
        return (Number(value)*100)?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }) + '%'
    }

    const getMonthTranslated = (dateStr) =>{
        return dateStr?.replace(/\b[a-zA-Z]{3}\b/, (match) => {
            const lower = match.toLowerCase();
            const translated = languages?.[lower];
            return translated || match;
        });
    }

    useEffect(()=> {
        if(id) {
            getPastPerformanceData();
            getPastScenarioDates();
        }
    }, [id])

    return <>
        <FlexContainer justify={'center'} width={'100%'}>
            <WrapperContainer maxwidth={'1440px'}>
                <HeaderContainer>
                {loading ? <LoadingEffect /> :
                <BackButtonWrap onClick={()=>navigate(`/${org}/products?lang=${language}`)}>
                        <DownArrowIcon
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </DownArrowIcon>
                        <span>{languages?.back_product}</span>
                    </BackButtonWrap>}
                    <HeaderTitleWrap>
                    {loading ? <LoadingEffect  width={'50%'}/> :<h1>{fundDetails?.web_share_class_name}</h1>}
                    </HeaderTitleWrap>
                    <IsnNumberWraper>
                    {loading ? <LoadingEffect width={'50%'}/> :<><span>ISIN: </span>
                        {fundDetails?.share_class_isin}</>}
                        {loading ? <LoadingEffect width={'50%'}/> :<div className="my-10"><span>{languages?.launch_date}: </span>
                        {getMonthTranslated(fundDetails?.launch_date)}</div>}
                        {loading ? <LoadingEffect width={'50%'}/> :<div><span>{languages?.nav_price}: </span>
                        <span>€ {fundDetails?.latest_month_end_nav_price} {languages?.as_on} {getMonthTranslated(fundDetails?.latest_month_end_date)}</span></div>}
                    </IsnNumberWraper>
                  <hr></hr>
                  <TabWrapper>
                    <Tabs>
                        <TabItem onClick={()=> setActiveTab('first')} className={`${activeTab === 'first' ? 'active' : ''}`}>{languages?.past_performance}</TabItem>
                        {version.length ? 
                        <TabItem onClick={()=> setActiveTab('second')} className={`${activeTab === 'second' ? 'active' : ''}`}>PRIIPS {languages?.performance_scenarios}</TabItem> : null}
                    </Tabs>
                  </TabWrapper>
                </HeaderContainer>
                <ContentWrapper>
                    {activeTab === 'first' ? fundDetails && Object.keys(fundDetails).length ? <>
                        <DescriptionWrapper margin={'0 16px'}>
                        {loading ? <LoadingEffect width={'50%'} height={'60px'}/> : performanceHistory > 1 ? <DescriptionItem className={'full-width font-bold'}>
                            <span>{languages.chart_top_text.replace('[x]', performanceHistory > 10 ? 10 : performanceHistory )}</span>
                            </DescriptionItem> : null}
                        </DescriptionWrapper>
                        {loading ? <LoadingEffect width={'50%'} height={'300px'} margin={'2% 0 0'}/> :<AnnualReport chartHeight={'400px'} chartWidth={'100%'}
                        dataSet={dataSet} labels={labels}
                        noDataText={performanceHistory < 1 || noData ? languages?.one_year_text?.replace('[Share Class launch date: DD Month YYYY]', getMonthTranslated(fundDetails?.launch_date)) : ''}
                        bottomtext={languages?.below_graph?.replace('[Share class name]', fundDetails?.share_class_name)?.replace("[DD Month YYYY]", getMonthTranslated(fundDetails?.launch_date))}
                        />}
                        {performanceHistory > 1 && !noData && <DescriptionWrapper>
                            {/* <DescriptionItem className={'font-bold'}>
                            <span>{languages.past_text_one}</span>
                            </DescriptionItem> */}
                            {/* <DescriptionItem className={'font-bold'}>
                            <span>{languages.past_text_two}</span>
                            </DescriptionItem> */}
                        </DescriptionWrapper>}
                    </> : <DescriptionWrapper>
                            <DescriptionItem className={'font-bold'}>
                            <span>{languages?.no_data}</span>
                            </DescriptionItem></DescriptionWrapper> :
                    <>
                        <DescriptionWrapper margin={'0 32px'}>
                            <DescriptionItem className={'full-width'}>
                            <span>{languages?.rhp_text.replace('[RHP + 5]', scenarioData?.recommended_holding_period+5)}
                            </span>
                            </DescriptionItem>
                        </DescriptionWrapper>
                        <SelectDropdown 
                        options={version} 
                        styles={{margin: '32px'}}
                        width={'520px'}
                        placeholder={languages?.version}
                        searchKey={'label'}
                        displayKey={'label'}
                        onSelect={(e)=> {getPastScenarioTable(e)}} 
                        defaultSelection={true}/>
                        {!tableLoading && <><TableContainer>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{fontSize: '14px'}} colSpan={5}>{languages?.recommended_pac?.replace('[year]', scenarioData?.recommended_holding_period || 0).replace('[amount]', scenarioData?.example_investment_amount || 0)}</th>
                                    </tr>
                                    <tr>
                                        <th>{languages?.scenarios}</th>
                                        <th className="hide-small"></th>
                                        <th width={'50px'}>1 {languages?.year}</th>
                                        {scenarioData?.half_recommended_holding_period && <th width={'50px'}>{scenarioData?.half_recommended_holding_period} {languages?.years}</th>}
                                        {scenarioData?.recommended_holding_period && <th width={'50px'}>{scenarioData?.recommended_holding_period} {languages?.years}</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th className="bold">{languages?.min_scenario}</th>
                                        <td className="hide-small bold">{languages?.no_min_guarantee}</td>
                                        <td></td>
                                        {scenarioData?.half_recommended_holding_period && <td></td>}
                                        {scenarioData?.recommended_holding_period && <td></td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.stress_scenario}</th>
                                        <td className="hide-small bold">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_stress_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_stress_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_stress_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td className="hide-small">{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_stress_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_stress_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_stress_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.unfav_scenario}</th>
                                        <td className="bold hide-small">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_unfavourable_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td className="hide-small">{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_unfavourable_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.mod_scenario}</th>
                                        <td className="bold hide-small">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_moderate_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td className="hide-small">{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_moderate_pcnt_rhp)}`}</td>}
                                    </tr>
                                    <tr>
                                        <th className="bold">{languages?.fav_scenario}</th>
                                        <td className="bold hide-small">{languages?.get_back}</td>
                                        <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_1y)}</td>
                                        {scenarioData?.half_recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_half_rhp)}</td>}
                                        {scenarioData?.recommended_holding_period && <td className="bold">€ {formatAmount(scenarioData.return_favourable_val_rhp)}</td>}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td className="hide-small">{languages?.average_return}</td>
                                        <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_1y)}`}</td>
                                        {scenarioData?.half_recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_half_rhp)}`}</td>}
                                        {scenarioData?.recommended_holding_period && <td>{`${formatPcnt(scenarioData.return_favourable_pcnt_rhp)}`}</td>}
                                    </tr>
                                </tbody>
                            </table>
                        </TableContainer></>}
                    </>}
                </ContentWrapper>
            </WrapperContainer>
        </FlexContainer>
    </>;
}

export default MiflInnerPage;